import {FieldPathValue, FieldValues, Path, useFormContext} from 'react-hook-form';

export const useFieldValue = <T extends FieldValues>(
   name: Path<T>,
   defaultValue?: any
): FieldPathValue<T, Path<T>> => {
   const methods = useFormContext<T>();

   return methods.watch(name) || defaultValue;
};
